module.exports = __webpack_public_path__ + "img/cclibs.d556653c.svg";